import type { LogLevelType } from 'loglayer';

export type FirestoreConfig = {
    exports: any;
};

export type Platform =
    'Production'
    | 'Alpha'
    | 'Beta'
    | 'Staging'
    | 'Noco'
    | 'local-dev'
    | 'Dev';

export type Flag<T = unknown> = boolean | ((args: T) => boolean);

export const FeatureFlags = {
  flagUseRentedAsProductTypes: 'flagUseRentedAsProductTypes',
  flagIsOperatedFilter: 'flagIsOperatedFilter',
  flagNewRateChangeEndpoint: 'flagNewRateChangeEndpoint', // Enable summary page metrics rate-change endpoint
  flagProductRateChangeEndpoint: 'flagProductRateChangeEndpoint', // Enable product page metrics rate-change endpoint
  flagRDOApiAlloyDBHeader: 'flagRDOApiAlloyDBHeader', // Enable AlloyDB header in UI Requests to RDO API
  flagEnableResponsive: 'flagEnableResponsive', // Enable responsive design changes
  flagSavedViews: 'flagSavedViews', // Enable saved views functionality
  flagMonthOnlyRateChange: 'flagMonthOnlyRateChange', // Use backend "month only" rate change for Product Type PoP Monthly Rates row (vs legacy client-side subtraction)
  flagSentryOnLocalhost: 'flagSentryOnLocalhost', // Enable Sentry on localhost for testing
} as const;

export type FeatureFlagsConfig = {
  [K in keyof typeof FeatureFlags]: Flag;
};


export type BuildEnvironment = FeatureFlagsConfig & {
    production?: boolean,
    apiUrl: string,
    clientId: string,
    domain: string,
    responseType: string,
    scope: string,
    logLevel?: LogLevelType,
    audience: string,
    softwareVersion: string,
    isPkceFlowMode: boolean,
    heapId: number,
    metricsApiUrl: string,
    cgTemplatesCanBeModified: boolean,
    enableUnpromptedGuidance: boolean,
    platform: Platform,
    ratesAndAvailabilityUrl: string,
    enableCompetitiveDisclaimer: boolean,
    sentryTraceSampleRate: number,
    ukTestingNames: string,
    dataDogSessionSampleRate: number,
    dataDogSessionReplayRate: number,
    /**
     * Firestore connection settings and actionable endpoints
     */
    firestore: FirestoreConfig
};
